<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    "$route"() {
      let thisPath = this.$route.path.split('/')[1];
      if (thisPath != "info" && thisPath != "read") {
        let url = window.location.href.split("#")[0];
        let obj = {
          title: "千年医典数据库",
          desc:
            "中外学者、古籍专家历时四十余年，先后对千余年来留存于日本和世界各国的中医文献进行系统整理而成",
          link: url,
          imgUrl:
            "http://shenhuanglive.oss-cn-shanghai.aliyuncs.com/image/test_img/5d77551d2963f.jpg"
        };
        this.$wxApi.getJSSDK(url, obj);
      }

      let locationHash = window.location.hash;
      sessionStorage.setItem("hashLocation",locationHash);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue